import {
  Operator,
  Property,
  RuleEngineConfig,
  RuleEngineConfigPropertyTypes,
} from '@app/react-common/components/rule-engine-v2/models/RuleEngineConfig';

export const AbtestRuleEngineConfig: RuleEngineConfig = {
  properties: [
    {
      property: Property.customerOrderCount,
      type: RuleEngineConfigPropertyTypes.Stepper,
      measuringUnit: 'all_time',
    },
    {
      property: Property.cartValue,
      type: RuleEngineConfigPropertyTypes.Stepper,
    },
    {
      property: Property.weight,
      type: RuleEngineConfigPropertyTypes.Weight,
      measuringUnit: 'lb',
    },
    {
      property: Property.vendor,
      type: RuleEngineConfigPropertyTypes.Autocomplete,
    },
    {
      property: Property.collection,
      type: RuleEngineConfigPropertyTypes.Autocomplete,
    },
    {
      property: Property.productType,
      type: RuleEngineConfigPropertyTypes.Autocomplete,
    },
    {
      property: Property.shopify_tags,
      type: RuleEngineConfigPropertyTypes.ContainsTextOrIsAutocomplete,
    },
    {
      property: Property.customerTag,
      type: RuleEngineConfigPropertyTypes.ContainsTextOrIsAutocomplete,
    },
    {
      property: Property.country,
      type: RuleEngineConfigPropertyTypes.NestedDropdown,
    },
    {
      property: Property.subscription,
      type: RuleEngineConfigPropertyTypes.Dropdown,
    },
    {
      property: Property.source,
      type: RuleEngineConfigPropertyTypes.Dropdown,
    },
    {
      property: Property.customerSpend,
      type: RuleEngineConfigPropertyTypes.Stepper,
    },
    {
      property: Property.weekday,
      type: RuleEngineConfigPropertyTypes.Dropdown,
    },
    {
      property: Property.hasACoupon,
      type: RuleEngineConfigPropertyTypes.Dropdown,
    },
    {
      property: Property.grossMargin,
      type: RuleEngineConfigPropertyTypes.Stepper,
      measuringUnit: 'percentage',
    },
    {
      property: Property.gender,
      type: RuleEngineConfigPropertyTypes.Dropdown,
    },
    {
      property: Property.variantTitle,
      type: RuleEngineConfigPropertyTypes.String,
    },
    {
      property: Property.sellingPlan,
      type: RuleEngineConfigPropertyTypes.String,
    },
    {
      property: Property.cartAttributeKey,
      type: RuleEngineConfigPropertyTypes.String,
    },
    {
      property: Property.cartAttributeValue,
      type: RuleEngineConfigPropertyTypes.String,
    },
    {
      property: Property.propertiesValue,
      type: RuleEngineConfigPropertyTypes.String,
    },
    {
      property: Property.propertiesKey,
      type: RuleEngineConfigPropertyTypes.String,
    },
    {
      property: Property.timeOfDay,
      type: RuleEngineConfigPropertyTypes.Dropdown,
    },
    {
      property: Property.locale,
      type: RuleEngineConfigPropertyTypes.String,
      conditionalType: (operator: Operator) => {
        if (operator === Operator.contains || operator === Operator.not_contains) {
          return RuleEngineConfigPropertyTypes.String;
        }
        return RuleEngineConfigPropertyTypes.Dropdown;
      },
    },
  ],
  visualConfig: {
    tooltipAppearOnAltSide: 'left',
  },
};
